<template>
  <div>
    <!-- トップページ用 -->
    <div v-if="$route.name === 'home'" class="header bg-cmain">
      <h1 class="page-title pl-3 text-left">
        {{ $route.meta.pageTitle }}<br />
        <span class="small">{{ surname }} {{ firstname }} さん</span>
      </h1>
      <b-button @click="logout()" variant="light">
        <span class="small">ログアウト</span>
      </b-button>
    </div>
    <!-- トップページ以外のページ用 -->
    <div v-else class="header bg-cmain">
      <button class="header-btn" @click="toPrevPage()">
        <b-icon icon="chevron-left" scale="1.5"></b-icon>
      </button>
      <h1 class="page-title">{{ $route.meta.pageTitle }}</h1>
      <button class="header-btn" @click="toHomePage()">
        <b-icon icon="house-door-fill" scale="1.5"></b-icon>
      </button>
    </div>
  </div>
</template>

<script>
import logger from '@/utils/logger'
export default {
  data() {
    return {
      surname: this.$store.getters.surname,
      firstname: this.$store.getters.firstname,
    }
  },
  methods: {
    toHomePage() {
      document.activeElement.blur()
      this.$router.push({ name: 'home' })
    },
    toPrevPage() {
      // 指定された戻り先または、一つ前に戻る
      if (this.$route.meta.prevPage) {
        this.$router.push({ name: this.$route.meta.prevPage })
      } else {
        this.$router.go(-1)
      }
    },
    logout() {
      logger.debug('** logout **')
      this.$store
        .dispatch('logout')
        .then((response) => {
          logger.debug(response)
          this.$router.push({ name: 'login' })
        })
        .catch((error) => {
          logger.error(error)
          // 401時はaxiosのinterceptorsでredirectを行う ここではそれ以外を対象にする
          if (!error.response || error.response.status !== 401) {
            this.$router.push({ name: 'login' })
          }
        })
    },
  },
}
</script>

<style>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
.header-btn {
  padding: 5px 10px;
  border: none;
  background-color: transparent;
  color: white;
}
.page-title {
  font-size: 2rem;
  margin: 0;
  color: white;
}
</style>
